<template>
    <v-dialog v-model="dialog" persistent max-width="800px">
        <v-btn slot="activator" color="blue" dark>Edit tracking number</v-btn>
        <v-card>
            <form v-on:submit.prevent="create">
                <v-card-title>
                    <span class="headline">Add new product</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 md12>
                                <v-text-field
                                        v-validate="'required'"
                                        v-model="data.track_number"
                                        :error-messages="errors.collect('data.track_number')"
                                        label="Track number:"
                                        data-vv-name="data.track_number"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="cancel()">Cancel</v-btn>
                    <v-btn color="blue darken-1" flat type="submit">Save</v-btn>
                </v-card-actions>
            </form>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ['sample_order_id', 'track_number'],
        data: () => ({
            dialog: false,
            data : null,
        }),
        created () {
            this.data = {
                sample_order_id: this.sample_order_id,
                track_number: this.track_number
            }
        },
        methods: {
            create () {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.$store.dispatch('editTrackNumber', this.data).then((res) => {
                            this.$emit('created');
                            this.dialog = false
                        }).catch((error) => {

                        });
                    }
                });
            },
            cancel () {
                this.dialog = false;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fnt/samples/components/TrackNumberComponent.vue